import { cn } from "../../utils/helpers";

interface ProgressProps {
    /** Array of steps the progress component
        should have
    */
    steps: string[];
    /** Current step of the progress component
         this value will be updated in the component
         in which it is being used
     */
    currentStep: string;
    /** Context in which progress bar is used
        just modal for now, more union types will be added
     */
    context?: "modal" | "others";
    /** additional classname */
    className?: string;
}

export default function Progress({
    steps,
    currentStep,
    className,
    context = "modal",
}: ProgressProps) {
    const stepsTuple = [...steps] as const;

    return (
        <div
            className={cn("bg-white", className, {
                "absolute top-16 w-full left-0 z-[2] py-[--paddind-card-y]":
                    context === "modal",
            })}
        >
            <div className="flex items-center h-1">
                {stepsTuple.map((item, i) => (
                    <span
                        role="presentation"
                        key={item}
                        className={cn(
                            "bg-stroke h-full flex-1 w-[calc(100%/(length(stepsTuple)+1))]",
                            {
                                "bg-primary":
                                    stepsTuple[i] === currentStep ||
                                    i <= stepsTuple.indexOf(currentStep),
                            }
                        )}
                    />
                ))}
            </div>
        </div>
    );
}
